import useProject from '@hooks/useProject';

function useKiccEasyCard() {
    const project = useProject();
    return !!project?.features.easyCardEnabled;
}

export default useKiccEasyCard;
